import { AdminTableColumnProps } from './admin-table-column-props';
import React from 'react';
import { TableColumn } from '@mint/ui';
import styled from 'styled-components';

type CompType = React.FunctionComponent<AdminTableColumnProps>;

export const AdminTableColumn = styled<CompType>(TableColumn)`
  box-sizing: border-box;
  max-width: 100%;
  display: flex;
`;
